<template>
 <v-dialog v-model="dialogNote" max-width="500px" persistent max-height="500px" style="overflow-y: hidden !important;">
  <v-card style="border-radius:20px;">
  <v-card tile>
    <v-toolbar card style="background: #1a222c !important;">
      <v-toolbar-title class="white--text CSChatThai"><v-icon color="white">fas fa-sticky-note</v-icon>&nbsp;&nbsp;{{$t('Dialog.note.headerNote')}}</v-toolbar-title>
        <v-spacer></v-spacer>
          <div v-if="tokenuser == datanote.owner && !edit">
            <v-menu bottom offset-y  v-if="status_block != 'block'">
              <v-btn dark icon flat slot="activator" row wrap>
                <v-icon style="font-size: 15px !important;">more_vert</v-icon>
              </v-btn>
              <v-list style="width: 140px;">
                <v-list-tile @click="edit = !edit">
                  <v-icon style="font-size: 15px;">edit</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai"> {{$t('AnswerQuestion.edit')}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile  @click="remove">
                  <v-icon style="font-size: 15px;">far fa-trash-alt</v-icon>&nbsp;&nbsp;<v-list-tile-title class="CSChatThai"> {{$t('AnswerQuestion.remove')}}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
        <v-btn dark icon flat @click="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
    </v-toolbar>
  </v-card>
  <v-card-text style="padding-left: 30px;">
    <v-progress-linear :indeterminate="progress" v-if="status == 'progress'"></v-progress-linear>
      <div v-else-if="status == 'show'">
        <v-layout align-center justify-start row wrap>
          <v-avatar class="user-photonote" >
            <img v-if="datanote.profilepicture" :src="datanote.profilepicture" class="alligator-turtle">
            <img v-else-if="datanote.type ==='business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
            <img v-else-if="datanote.type ==='bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
            <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
          </v-avatar>
          <p style="font-size: 18px; padding-left: 10px; padding-top: 10px;" class="text2">{{datanote.nickname}}</p>
          <span style="font-size: 10px;position: absolute;right: 10px;color: #5a616b !important;">
            {{date(datanote.create_date)}} {{time(datanote.create_date)}}
          </span>
        </v-layout>
        <div style="max-height:200px; min-height:100px; margin-top: 10px; word-break: break-all;" class="scrolling-wrapper">
          <div v-if="edit" style="width: 100%;" >
            <textarea v-model="edittext" style="width: 100%; height: 150px; background: #1a222b12;padding: 20px;" class="scrolling-wrapper">
            </textarea>
          </div>
        <p v-else style="" class="" v-html="convert(datanote.note_data.text ).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
        </div>
        <div>
          <v-layout align-center justify-center row wrap>
            <v-flex xs6 md6 sm6>
              <v-layout align-center justify-end row wrap style="padding-right: 10px;">
                <v-btn dark @click="cancel" v-if="tokenuser == datanote.owner && edit" class="btncancel text-transform">{{$t('AnswerQuestion.cancel')}}
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs6 md6 sm6>
              <v-layout align-center justify-start row wrap>
                <v-btn  dark @click="save" v-if="tokenuser == datanote.owner && edit" class="btnallow text-transform">{{$t('AnswerQuestion.ok')}}
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div v-else-if="status == 'error'" style="text-align: center;">
        <br>
         <v-icon style="color: #757575 !important; font-size: 80px !important;">error_outline</v-icon>
         <br><br>
        <p style="font-size: 20px; color: #757575;"> {{errormessage}} </p>
      </div>
    </v-card-text>
  </v-card>
</v-dialog>
<!-- <v-dialog v-model="dialognote" v-else></v-dialog> -->
</template>
<script>
import { Momenttime, Decode } from '@/services'
export default {
  props: {dialogNote: false, note_id: '' , status_block: String},
  data: () => ({
    datanote: {note_data: {text: 'test'}},
    tokenuser: '',
    edit: false,
    edittext: '',
    preedittext: '',
    progress: true,
    status: 'show',
    errormessage: ''
  }),
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.tokenuser = decoded['tokenuser']
  },
  methods: {
    closeDialog () {
      this.$emit('closeNote', false)
      this.edit = false
    },
    remove () {
      this.$swal({
        type: 'warning',
        title: `<div class="CSChatThai" style="font-size: 16px;">${this.$t('Dialog.note.deleteNote')}</div>`,
        confirmButtonColor: '#d33',
        confirmButtonText: `<div class="CSChatThai" style="font-size: 14px;">${this.$t('AnswerQuestion.ok')}</div>`,
        cancelButtonColor: '#3085d6',
        cancelButtonText: `<div class="CSChatThai" style="font-size: 14px;">${this.$t('AnswerQuestion.cancel')}</div>`,
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then((result) => {
        // console.log(result.value)
        if (result.value) {
          this.axios.post(process.env.APImanage + '/removenote', {note_id: this.note_id, tokenuser: this.tokenuser}).then((response) => {
            if (response.data.status === 'success') {
              this.status = 'error'
              this.errormessage = this.$t('Dialog.note.noNote')
              this.$emit('removeNote', this.note_id)
              this.closeDialog()
            } else {
              this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
            }
          })
        }
      })
    },
    save () {
      this.edit = false
      if (this.edittext !== this.preedittext) {
        this.datanote.note_data.text = this.edittext
        this.preedittext = this.edittext
        this.axios.post(process.env.APImanage + '/editnote', {note_id: this.note_id, tokenuser: this.tokenuser, text: this.edittext}).then((response) => {
          if (response.data.status === 'success') {
            // console.log(response.data)
            this.$emit('editNote', this.edittext, this.note_id)
          } else {
            this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
          }
        })
      }
    },
    cancel () {
      this.edit = false
      this.edittext = this.preedittext
    },
    date (timestamp) {
      // return Momenttime.momentdatethai(timestamp)
      if (this.$i18n.locale == 'th') {
        return Momenttime.momentdatethai(timestamp)
      } else if (this.$i18n.locale == 'cn') {
        return Momenttime.momentdatecn(timestamp)
      } else {
        return Momenttime.momentdateen(timestamp)
      }
    },
    time (timestamp) {
      return Momenttime.momenttimethai(timestamp)
    },
    convert (msg) {
      var linkifyStr = require('linkifyjs/string')
      var str = msg
      var processedContent = linkifyStr(str)
      return processedContent
    }
  },
  watch: {
    dialogNote () {
      if (this.dialogNote) {
        this.datanote.note_data.text = 'test'
        this.progress = true
        this.status = 'progress'
        this.axios.post(process.env.APImanage + '/getnote', {note_id: this.note_id}).then((response) => {
          if (response.data.list_note.length !== 0) {
            this.status = 'show'
            this.progress = false
            this.datanote = response.data.list_note[0]
            this.edittext = response.data.list_note[0].note_data.text
            this.preedittext = response.data.list_note[0].note_data.text
          } else {
            this.progress = false
            this.status = 'error'
            this.errormessage = this.$t('Dialog.note.noNote')
          }
        })
      }
    }



    // note_id () {
    //   // console.log(this.note_id + 'dd')
    //   this.datanote.note_data.text = 'test'
    //   this.progress = true
    //   this.status = 'progress'
    //   this.axios.post(process.env.APImanage + '/getnote', {note_id: this.note_id}).then((response) => {
    //     if (response.data.list_note.length !== 0) {
    //       this.status = 'show'
    //       this.progress = false
    //       this.datanote = response.data.list_note[0]
    //       this.edittext = response.data.list_note[0].note_data.text
    //       this.preedittext = response.data.list_note[0].note_data.text
    //     } else {
    //       this.progress = false
    //       this.status = 'error'
    //       this.errormessage = 'ขออภัย!! โน๊ตนี้ถูกลบแล้ว'
    //     }
    //   })
    // }
  }
}
</script>
<style type="text/css" scoped>
.text-transform {
  text-transform: none;
}
.scrolling-wrapper {
  display: flex;
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 10px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
.text2 {
  white-space: nowrap;
  width: 107px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #2562af !important;
  color: white !important;
}
.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #e0e0e0 !important;
  color: black !important;
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
.application .theme--light.input-group input, .application .theme--light.input-group textarea, .theme--light .input-group input, .theme--light .input-group textarea {
    /* color: rgba(0,0,0,.87); */
    color: #53ceff !important;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.user-photonote{
  height: 40px !important;
  width: 40px !important;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;

}

.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display:inline-flex;
}
input[type=textadd] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    /*background-image: url('../assets/image/group.png');*/
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 12px 12px 12px 12px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/dialog/NoteDialogMobile.vue